import type { PartialPageSlug } from '../cms/schemas';
import { PartialPageSlugSchema } from '../cms/schemas';

export const PAGE_PARTIAL_SLUG: Array<PartialPageSlug> = [
  PartialPageSlugSchema.Enum['download-app'],
  PartialPageSlugSchema.Enum['esim-compatibility'],
  PartialPageSlugSchema.Enum['unlimited-international'],
];
